import { extendTheme } from '@chakra-ui/react';
import semanticTokens from './semanticTokens';

const theme = extendTheme({
  colors: {
    // Map terracotta as 'orange' colorScheme for buttons
    orange: {
      50:  '#FDF0ED',
      100: '#F9D5CD',
      200: '#F4B3A4',
      300: '#EE8E7C',
      400: '#D96A55',
      500: '#C8553D',  // base terracotta
      600: '#A84432',
      700: '#873628',
      800: '#62271D',
      900: '#3E1812',
    },
    // Forest green mapped as 'green' colorScheme
    green: {
      50:  '#EBF5EE',
      100: '#C8E4CF',
      200: '#A2CFB0',
      300: '#7AB991',
      400: '#5FA376',
      500: '#4A7C59',  // base forest green
      600: '#3D6649',
      700: '#30503A',
      800: '#22392A',
      900: '#14221A',
    },
  },
  semanticTokens,
  fonts: {
    heading: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    body: "'Space Grotesk', -apple-system, BlinkMacSystemFont, 'Segoe UI', Helvetica, Arial, sans-serif",
    mono: "'JetBrains Mono', ui-monospace, SFMono-Regular, Menlo, monospace",
  },
  config: {
    initialColorMode: 'system',
    useSystemColorMode: true,
  },
  styles: {
    global: {
      body: {
        bg: 'bg.canvas',
        color: 'text.primary',
        backgroundImage: `
          radial-gradient(at 0% 0%,     rgba(var(--chakra-colors-brand-primary-rgb),   0.10) 0px, transparent 55%),
          radial-gradient(at 100% 0%,   rgba(var(--chakra-colors-brand-secondary-rgb), 0.10) 0px, transparent 55%),
          radial-gradient(at 100% 100%, rgba(var(--chakra-colors-brand-primary-rgb),   0.07) 0px, transparent 55%),
          radial-gradient(at 0% 100%,   rgba(var(--chakra-colors-brand-secondary-rgb), 0.07) 0px, transparent 55%)
        `,
      },
      '::-webkit-scrollbar-track': {
        bg: 'rgba(var(--chakra-colors-brand-primary-rgb), 0.05)',
      },
      '::-webkit-scrollbar-thumb': {
        bg: 'rgba(var(--chakra-colors-brand-primary-rgb), 0.25)',
      },
      '::-webkit-scrollbar-thumb:hover': {
        bg: 'rgba(var(--chakra-colors-brand-primary-rgb), 0.40)',
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: '8px',
        letterSpacing: '0.01em',
      },
    },
    Heading: {
      baseStyle: {
        fontWeight: '700',
        letterSpacing: '-0.02em',
      },
    },
    Link: {
      baseStyle: {
        transition: 'color 0.2s ease',
        _hover: {
          textDecoration: 'none',
        },
      },
    },
  },
});

export default theme;
